import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import InfoGridItem from './info-grid-item';
import ManageIcon from './images/manage-icon.png';
import CollaborateIcon from './images/collaborate-icon.png';
import TrainIcon from './images/train-recruit-icon.png';

const InfoPanel = () => (
    <Container
        sx={{
            textAlign: 'center',
        }}
    >
        <Box mb={4}>
            <Typography variant="h1" mb={4} style={{ color: '#1F192C' }}>
                Who should use Virtual Law Clinic?
            </Typography>
            <Typography variant="body1" mb={12} sx={{ color: '#5B5770', lineHeight: { mobile: 'normal', desktop: 'inherit' } }}>
                Virtual Law Clinic is a centralized hub to manage pro bono matters, create training materials, and collaborate with inside and outside attorneys in representing pro bono clients.
            </Typography>
        </Box>
        <Grid container spacing={9}>
            <InfoGridItem
                icon={ManageIcon}
                iconAltText="Manage Icon"
                title="Law Firms"
                text="Increase your impact with streamlined pro bono management and multi-organizational collaboration on pro bono matters."
            />
            <InfoGridItem
                icon={CollaborateIcon}
                iconAltText="Collaborate Icon"
                title="Legal Service Organizations"
                text="Simplify training and monitoring of volunteer lawyers. Provide them with the tools they need to best represent your clients and ensure effective representation by monitoring activities."
            />
            <InfoGridItem
                icon={TrainIcon}
                iconAltText="Train and Recruit Icon"
                title="Corporate Legal Departments"
                text="Centralize your department's pro bono efforts in one place. Increase efficiency and organization as you partner with outside firms and legal service organizations on pro bono matters."
            />
        </Grid>
    </Container>
);

export default InfoPanel;
